import script from "./cascadingSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./cascadingSelect.vue?vue&type=script&lang=ts&setup=true"

import "./cascadingSelect.vue?vue&type=style&index=0&id=2584f6fb&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2584f6fb"]])

export default __exports__